import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faTimes,
} from '@fortawesome/fontawesome-free-solid';

class AnswerEdit extends Component {

  render() {
    return (
      <li>
        <div className="answer-container">
          <input className="edit-answer-input" type="text" name="editAnswerText" value={this.props.editAnswerText} onChange={this.props.handleChange} />
          <span className="answer-options-edit">
            <span onClick={this.props.confirmAnswerEdit}>
              <FontAwesomeIcon icon="check" /></span>
            <span >
              <FontAwesomeIcon icon="times" onClick={this.props.cancelAnswerEdit} /></span>
          </span>
        </div>
      </li>
    )
  }
}

export default AnswerEdit;



// WEBPACK FOOTER //
// ./src/components/questions/modify/AnswerEdit.js